module.exports = __webpack_public_path__ + "img/invoice.d27c14f0.svg";